"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZUIProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTooltip = require("@radix-ui/react-tooltip");
require("./styles/main.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ZUIProvider = _ref => {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_reactTooltip.TooltipProvider, null, children);
};
exports.ZUIProvider = ZUIProvider;
//# sourceMappingURL=ZUIProvider.js.map